export type RequestType = 'AGGREGATED_VALUE'| 'AGGREGATED_VALUES' | 'VALUES' |'RANGE' | 'LATEST' | 'INSTANT' | 'INSTANT_AFTER' | 'INSTANT_BEFORE';
export const RequestTypeArray: readonly RequestType[] = [
  'AGGREGATED_VALUE',
  'AGGREGATED_VALUES',
  'VALUES',
  'RANGE',
  'LATEST',
  'INSTANT',
  'INSTANT_AFTER',
  'INSTANT_BEFORE'
];
